module.exports = __webpack_public_path__ + "/images/cover-cta-libro-lucia-m.34b31c3.png";